const registry = {};
function registerMapper(name, fn) {
    registry[name] = fn;
}
function getMapper(name) {
    return registry[name];
}

export { getMapper, registerMapper };
